import { mergeStyles } from "@fluentui/react";

export const profileBoxContainerStyles = mergeStyles([{
    width: '100%',
    height: '30dvh'
}]);

export const profileBoxUserImageStyles = mergeStyles([{
    width: '12dvh',
    height: '12dvh',
    backgroundColor: '#2A7DE1',
    borderRadius: '50%',
    fontFamily: 'Nunito',
    fontSize: '3dvh',
    fontWeight: '700',
    color: '#FFFFFF'
}]);

export const profileBoxTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(16px, 3dvh, 48px)',
    fontWeight: 500,
    textAlign: 'center',
    color: '#323130'
}]);

export const profileBoxEmailStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(11px, 1.5dvh, 48px)',
    fontWeight: 300,
    textAlign: 'center',
    color: '#323130'
}]);

export const profileBoxIconStyles = mergeStyles([{
    fontSize: 'clamp(11px, 1.5dvh, 48px)',
    color: '#2A7DE1',
    fontWeight: 300,
    textAlign: 'center',
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)'
}]);